const LAST_VISITED_PRODUCT_KEY = 'lastVisitedProduct';
const LAST_VISITED_PRODUCT_ARRAY_KEY = 'lastVisitedProducts';
const LAST_VISITED_PRODUCTS_ARRAY_SIZE = 10;

var LastVisitedProductJS = (function($) {

    const isPdp = function() {
        return $(':input[name="productPage"]').val();
    }

    //consider the difference in usage between search page and main page
    const isHomePage = function() {
        return true;
    }

    const saveProductToLS = function(id, type, vehicleId, vehicle_ids, wheelId, wheelIdWithTpms, tyreId) {
        const lastVisitedProduct = {
            id: id,
            type: type,
            lv_vehicleId: vehicleId,
            lv_vehicle_ids: vehicle_ids,
            lv_wheelId: wheelId,
            lv_wheelIdWithTpms: wheelIdWithTpms,
            lv_tyreId: tyreId
        };
        localStorage.setItem(LAST_VISITED_PRODUCT_KEY, JSON.stringify(lastVisitedProduct));
    }

    const saveProductToArrayLS = function(id, type) {
        let lastVisitedProducts = JSON.parse(localStorage.getItem(LAST_VISITED_PRODUCT_ARRAY_KEY));
        if (lastVisitedProducts == null) {
            lastVisitedProducts = {};
            lastVisitedProducts[type] = [id];
            localStorage.setItem(LAST_VISITED_PRODUCT_ARRAY_KEY, JSON.stringify(lastVisitedProducts));
        } else {
            if (typeof lastVisitedProducts[type] == 'undefined') {
                lastVisitedProducts[type] = [];
            }
            if (lastVisitedProducts[type].includes(id)) {
                lastVisitedProducts[type] = lastVisitedProducts[type].filter(function(value) {
                    return value != id;
                });
            }
            if (lastVisitedProducts[type].length >= LAST_VISITED_PRODUCTS_ARRAY_SIZE) {
                lastVisitedProducts[type].shift();
            }
            lastVisitedProducts[type].push(id);
            localStorage.setItem(LAST_VISITED_PRODUCT_ARRAY_KEY, JSON.stringify(lastVisitedProducts));
        }
    }

    const appendToFormLastVisitedProduct = function($form) {
        let lastVisitedProduct = fetchLastVisitedProductFromLS();
        if (isLiteTheme()) {
            let code = getLastVisitedTyreCode();
            lastVisitedProduct = {'id' : code, 'type': 'tyre'};
        }
        if (lastVisitedProduct !== null) {
            createHiddenInput('type', lastVisitedProduct.type).appendTo($form);
            createHiddenInput('id', lastVisitedProduct.id).appendTo($form);
            createHiddenInput('lv_vehicleId', lastVisitedProduct.lv_vehicleId).appendTo($form);
            createHiddenInput('lv_vehicle_ids', lastVisitedProduct.lv_vehicle_ids).appendTo($form);
            createHiddenInput('lv_wheelId', lastVisitedProduct.lv_wheelId).appendTo($form);
            createHiddenInput('lv_wheelIdWithTpms', lastVisitedProduct.lv_wheelId).appendTo($form);
            createHiddenInput('lv_tyreId', lastVisitedProduct.lv_tyreId).appendTo($form);
        }
    }

    // All visited tyres for the serp page
    const renderAllVisitedTyres = function(type, placeSelector) {
        $.ajax({
            url: "/tyres/allLastVisited",
            type: "POST",
            beforeSend: function(xhr) {
                xhr.setRequestHeader("X-CSRF-TOKEN", $("input[name='_csrf']").val());
            },
            contentType: "application/json; charset=utf-8",
            data: JSON.stringify(fetchLastVisitedProductFromArrayLS("tyre")),
            success: function(data) {
                if (!data.includes("action=\"/aro-login\" method=\"POST\"")) {
                    $(placeSelector).replaceWith(data);
                }
            }
        });
    }

    function createHiddenInput(name, value) {
        return $('<input type="hidden" />')
                    .attr('name', name)
                    .attr('value', value);
    }

    function fetchLastVisitedProductFromLS() {
        return JSON.parse(localStorage.getItem(LAST_VISITED_PRODUCT_KEY));
    }

    function fetchLastSearchedProductFromLS() {
        return JSON.parse(localStorage.getItem(LAST_SEARCHED_PRODUCT_KEY));
    }

    function fetchLastVisitedProductFromArrayLS(type) {
        var allVisitedProductsByType = JSON.parse(localStorage.getItem(LAST_VISITED_PRODUCT_ARRAY_KEY));
        return allVisitedProductsByType === null ? [] : allVisitedProductsByType[type];
    }

    function getLastVisitedTyreCode() {
        var lastVisitedProduct = fetchLastVisitedProductFromLS();
        var lastVisitedArrayProduct = fetchLastVisitedProductFromArrayLS('tyre');

        var code = undefined;
        if (lastVisitedProduct !== null) {
            code = lastVisitedProduct.id
            if (lastVisitedProduct.type !== 'tyre') {
                code = lastVisitedArrayProduct.slice(-1)[0];
            }
        }
        return code;
    }

    function isLiteTheme() {
        if (ACC.config.language === undefined) {
            return false;
        }
        return "RD" == ACC.config.language.split('_').slice(-1)[0];
    }

    return {
        isPdp: isPdp,
        saveProductToLS: saveProductToLS,
        saveProductToArrayLS: saveProductToArrayLS,
        renderAllVisitedTyres: renderAllVisitedTyres,
        isHomePage: isHomePage,
        appendToFormLastVisitedProduct: appendToFormLastVisitedProduct
    }

})($);

$(document).ready(function () {
    if (LastVisitedProductJS.isPdp()) {
        const id = $(':input[name="code"]').val();
        var type = $(':input[name="productPageType"]').val();
        type = type !== undefined ? type : 'tyre';
        const vehicleId = $(':input[name="vehicleId"]').val();
        const vehicle_ids = $(':input[name="vehicle_ids"]').val();
        const wheelId = $(':input[name="wheelId"]').val();
        const wheelIdWithTpms = $(':input[name="wheelIdWithTpms"]').val();
        const tyreId = $(':input[name="tyreId"]').val();
        LastVisitedProductJS.saveProductToLS(id, type, vehicleId, vehicle_ids, wheelId, wheelIdWithTpms, tyreId);
        LastVisitedProductJS.saveProductToArrayLS(id, type);
    }

    if (LastVisitedProductJS.isHomePage()) {}
});